import React, { createContext, useContext, useState, ReactNode } from 'react';
import { PreBidDetailData } from '../lib/api/user/userApi.types';

interface BidContextType {
  currentLotData: PreBidDetailData | null;
  setCurrentLotData: (data: PreBidDetailData | null) => void;
  clearLotData: () => void;
}

const BidContext = createContext<BidContextType | undefined>(undefined);

interface BidProviderProps {
  children: ReactNode;
}

export const BidProvider: React.FC<BidProviderProps> = ({ children }) => {
  const [currentLotData, setCurrentLotData] = useState<PreBidDetailData | null>(null);

  const clearLotData = () => {
    setCurrentLotData(null);
  };

  const value = {
    currentLotData,
    setCurrentLotData,
    clearLotData,
  };

  return (
    <BidContext.Provider value={value}>
      {children}
    </BidContext.Provider>
  );
};

export const useBidContext = () => {
  const context = useContext(BidContext);
  if (context === undefined) {
    throw new Error('useBidContext must be used within a BidProvider');
  }
  return context;
};
